import { DirectoryUser } from '@/models/directory-user.model';
import { InitialsPipe } from '@/pipes/initials.pipe';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { UserData } from 'src/app/models/user-data.model';
import { genericProfileImg } from 'src/app/services/data/generic-profile';


@Component({
    selector: 'app-user-image',
    imports: [
    CommonModule,
    ButtonModule,
    MenuModule,
    AvatarModule,
    InitialsPipe,
],
    template: `
                <p-avatar *ngIf="user; else initAvatar" size="large" [image]="getImage()" class="bg-teal-100 inline-flex align-items-center justify-content-center m-3 mr-3"/>
                <ng-template #initAvatar><p-avatar [label]="user?.DisplayName || '' | initials" size="large" /></ng-template>              
  `,
    styles: [`
        :host ::ng-deep .p-avatar img { border-radius: var(--border-radius) !important; }
        :host ::ng-deep .p-avatar { border-radius: var(--border-radius) !important; }
        :host ::ng-deep .p-card-body { padding: 0.5rem; }
      `]
})
export class UserImageComponent {
 @Input() user: UserData | DirectoryUser | undefined = undefined;
 genericPersonImage64: string = genericProfileImg;

 getImage() {
    if(!this.user) return '';
  if(this.user instanceof UserData) {
    return this.user.profilePicture;
  } else {
    return this.user.photoUrl;
  }
 }

 getUserDisplayName() {
    if(!this.user) return '';
  if(this.user instanceof UserData) {
    return this.user.displayName;
  } else {
    return this.user.DisplayName;
  }
 }

}
